<template>
  <div>
    <Modal
      v-model="show"
      :title="type == 'add' ?$t('add'):$t('edit')"
      :mask-closable="false"
      width="1200"
      @on-cancel="cancel"
    >
      <div class="modal">
        <Form ref="form" :model="form" :rules="ruleInline" :label-width="160" label-colon>
          <Tabs :value="tabs" @on-click="ontabs" :animated="false">
            <Row :gutter="15" class="list">
              <Col span="12">
                <TabPane :label="$t('Langue.zn')" name="1">
                  <FormItem class="item_input" prop="zh-cn_cname" :label="$t('Ad.name_home')">
                    <Input type="text" v-model="form['zh-cn_cname']" placeholder="请输入首页广告名称"></Input>
                  </FormItem>
                  <FormItem :label="$t('img_lnk')+' - PC'" prop="zh-cn_image">
                    <Upload
                      ref="upload"
                      :show-upload-list="false"
                      :before-upload="(value)=>handleBeforeUpload(value,1)"
                      type="drag"
                      action
                      style="display: inline-block;width:300px;height: 150px;"
                    >
                      <div class="demo-upload-list" v-if="form['zh-cn_image'] != ''">
                        <template>
                          <img :src="form['zh-cn_image']" />
                        </template>
                      </div>
                      <div v-else style="width: 300px;height:150px;line-height: 165px;">
                        <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                      </div>
                    </Upload>
                    <div
                      class="photo_tip"
                    >{{$t('photo_tip')+$t('static')+" 1200*200 "+$t('and')+$t('rotation')+" 1200 x 630"}}</div>
                    <div>
                      <Button type="primary" @click="onCopyImgPc(1)">{{ $t('Copy_language') }}</Button>
                    </div>
                  </FormItem>
                  <FormItem :label="$t('img_lnk')+' - Mobile'" prop="zh-cn_mobile_img">
                    <Upload
                      ref="upload"
                      :show-upload-list="false"
                      :before-upload="(value)=>handleBeforeUpload(value,4)"
                      type="drag"
                      action
                      style="display: inline-block;width:300px;height: 150px;"
                    >
                      <div class="demo-upload-list" v-if="form['zh-cn_mobile_img'] != ''">
                        <template>
                          <img :src="form['zh-cn_mobile_img']" />
                        </template>
                      </div>
                      <div v-else style="width: 300px;height:150px;line-height: 165px;">
                        <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                      </div>
                    </Upload>
                    <div
                      class="photo_tip"
                    >{{$t('photo_tip')+$t('static')+" 360*100 "+$t('and')+$t('rotation')+" 360*200"}}</div>
                    <div>
                      <Button type="primary" @click="onCopyImg(1)">{{ $t('Copy_language') }}</Button>
                    </div>
                  </FormItem>
                </TabPane>
                <TabPane :label="$t('Langue.tw')" name="2">
                  <FormItem class="item_input" prop="zh-tw_cname" :label="$t('Ad.name_home')">
                    <Input type="text" v-model="form['zh-tw_cname']" placeholder="請輸入首頁廣告名稱"></Input>
                  </FormItem>
                  <FormItem :label="$t('img_lnk')+' - PC'" prop="zh-tw_image">
                    <Upload
                      ref="upload"
                      :show-upload-list="false"
                      :before-upload="(value)=>handleBeforeUpload(value,2)"
                      type="drag"
                      action
                      style="display: inline-block;width:300px;height: 150px;"
                    >
                      <div class="demo-upload-list" v-if="form['zh-tw_image']!= ''">
                        <template>
                          <img :src="form['zh-tw_image']" />
                        </template>
                      </div>
                      <div v-else style="width: 300px;height:150px;line-height: 165px;">
                        <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                      </div>
                    </Upload>
                    <div
                      class="photo_tip"
                    >{{$t('photo_tip')+$t('static')+" 1200*200 "+$t('and')+$t('rotation')+" 1200 x 630"}}</div>
                    <div>
                      <Button type="primary" @click="onCopyImgPc(2)">{{ $t('Copy_language') }}</Button>
                    </div>
                  </FormItem>
                  <FormItem :label="$t('img_lnk')+' - Mobile'" prop="zh-tw_mobile_img">
                    <Upload
                      ref="upload"
                      :show-upload-list="false"
                      :before-upload="(value)=>handleBeforeUpload(value,5)"
                      type="drag"
                      action
                      style="display: inline-block;width:300px;height: 150px;"
                    >
                      <div class="demo-upload-list" v-if="form['zh-tw_mobile_img']!= ''">
                        <template>
                          <img :src="form['zh-tw_mobile_img']" />
                        </template>
                      </div>
                      <div v-else style="width: 300px;height:150px;line-height: 165px;">
                        <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                      </div>
                    </Upload>
                    <div
                      class="photo_tip"
                    >{{$t('photo_tip')+$t('static')+" 360*100 "+$t('and')+$t('rotation')+" 360*200"}}</div>
                    <div>
                      <Button type="primary" @click="onCopyImg(2)">{{ $t('Copy_language') }}</Button>
                    </div>
                  </FormItem>
                </TabPane>
                <TabPane :label="$t('Langue.en')" name="3">
                  <FormItem class="item_input" prop="en_cname" :label="$t('Ad.name_home')">
                    <Input
                      type="text"
                      v-model="form.en_cname"
                      placeholder="Please enter the advertisement name on the home page"
                    ></Input>
                  </FormItem>
                  <FormItem :label="$t('img_lnk')+' - PC'" prop="en_image">
                    <Upload
                      ref="upload"
                      :show-upload-list="false"
                      :before-upload="(value)=>handleBeforeUpload(value,3)"
                      type="drag"
                      action
                      style="display: inline-block;width:300px;height: 150px;"
                    >
                      <div class="demo-upload-list" v-if="form.en_image != ''">
                        <template>
                          <img :src="form.en_image" />
                        </template>
                      </div>
                      <div v-else style="width: 300px;height:150px;line-height: 165px;">
                        <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                      </div>
                    </Upload>
                    <div
                      class="photo_tip"
                    >{{$t('photo_tip')+$t('static')+" 1200*200 "+$t('and')+$t('rotation')+" 1200 x 630"}}</div>
                    <div>
                      <Button type="primary" @click="onCopyImgPc(3)">{{ $t('Copy_language') }}</Button>
                    </div>
                  </FormItem>
                  <FormItem :label="$t('img_lnk')+' - Mobile'" prop="en_mobile_img">
                    <Upload
                      ref="upload"
                      :show-upload-list="false"
                      :before-upload="(value)=>handleBeforeUpload(value,6)"
                      type="drag"
                      action
                      style="display: inline-block;width:300px;height: 150px;"
                    >
                      <div class="demo-upload-list" v-if="form.en_mobile_img != ''">
                        <template>
                          <img :src="form.en_mobile_img" />
                        </template>
                      </div>
                      <div v-else style="width: 300px;height:150px;line-height: 165px;">
                        <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                      </div>
                    </Upload>
                    <div
                      class="photo_tip"
                    >{{$t('photo_tip')+$t('static')+" 360*100 "+$t('and')+$t('rotation')+" 360*200"}}</div>
                    <div>
                      <Button type="primary" @click="onCopyImg(3)">{{ $t('Copy_language') }}</Button>
                    </div>
                  </FormItem>
                </TabPane>
              </Col>
              <Col span="12">
                <FormItem prop="beginDate" :label="$t('Ad.beginDate')">
                  <DatePicker
                    type="datetime"
                    format="yyyy-MM-dd HH:mm:ss"
                    :placeholder="tabs == 1 ? '请输入发布时间':tabs == 2 ? '請輸入發佈時間':'Please enter the release time'"
                    v-model="form.beginDate"
                    @on-change="changeDate"
                  />
                </FormItem>
                <FormItem prop="endDate" :label="$t('Ad.endDate')">
                  <DatePicker
                    type="datetime"
                    format="yyyy-MM-dd HH:mm:ss"
                    :placeholder="tabs == 1 ? '请输入下架时间':tabs == 2 ? '請輸入下架時間':'Please enter the takedown time'"
                    v-model="form.endDate"
                    @on-change="changeDate2"
                  ></DatePicker>
                </FormItem>
                <FormItem prop="sort_id" :label="$t('sort')">
                  <InputNumber
                    :min="1"
                    v-model="form.sort_id"
                    :placeholder="tabs == 1 ? '请输入排序顺序':tabs == 2 ? '請輸入排序順序':'Please enter the sort order'"
                  ></InputNumber>
                </FormItem>
                <FormItem :label="$t('Info.url')+' - PC'" prop="url_link">
                  <Input
                    type="text"
                    v-model="form.url_link"
                    :placeholder="tabs == 1 ? '请输入跳转连接':tabs == 2 ? '請輸入跳轉連接':'Please enter jump connection'"
                  ></Input>
                </FormItem>
                <FormItem :label="$t('Info.url')+' - Mobile'" prop="mobile_link_url">
                  <Input
                    type="text"
                    v-model="form.mobile_link_url"
                    :placeholder="tabs == 1 ? '请输入跳转连接':tabs == 2 ? '請輸入跳轉連接':'Please enter jump connection'"
                  ></Input>
                </FormItem>
                <FormItem :label="$t('isJump')" prop="link_type">
                  <i-Switch size="large" v-model="form.link_status" true-value="1" false-value="0" />
                </FormItem>
                <FormItem :label="$t('external_link')" prop="link_status">
                  <i-Switch size="large" v-model="form.link_type" true-value="1" false-value="0" />
                </FormItem>
                <FormItem :label="$t('Whether_by')" prop="ad_type">
                  <i-Switch size="large" v-model="form.ad_type" true-value="1" false-value="0" />
                </FormItem>
                <FormItem :label="$t('status')" prop="status">
                  <i-Switch size="large" v-model="form.status" true-value="1" false-value="0" />
                </FormItem>
              </Col>
            </Row>
          </Tabs>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="cancel()">{{ $t("cancel") }}</Button>
        <Button type="primary" @click="submit('form')">{{ $t("sure") }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    itemObj: Object,
    type: String
  },
  data () {
    const validateImg = (rule, value, callback) => {
      if (value == '') {
        callback(new Error(this.$t('p_upload_img')));
      } else {
        callback();
      }
    };
    return {
      tabs: '1',
      form: {
        ad_item_id: "",
        ad_id: "",
        sort_id: null,
        begin_date: "",
        end_date: "",
        url_link: "",
        status: "0",
        mobile_link_url: "",
        link_status: "0",
        link_type: "0",
        ad_type: "0",
        "zh-cn_cname": "",
        "zh-cn_cdesc": "",
        "zh-cn_image": "",
        "zh-cn_button": "",
        "zh-tw_cname": "",
        "zh-tw_cdesc": "",
        "zh-tw_image": "",
        "zh-tw_button": "",
        en_cname: '',
        en_cdesc: "",
        en_image: "",
        en_button: "",
        beginDate: "",
        endDate: "",
        "zh-tw_mobile_img": "",
        "zh-cn_mobile_img": "",
        en_mobile_img: ""
      },
      ruleInline: {
        'zh-cn_cname': [
          {
            required: true,
            message: this.$t("Ad.name_home_input"),
            trigger: "blur"
          }
        ],
        'zh-tw_cname': [
          {
            required: true,
            message: this.$t("Ad.name_home_input"),
            trigger: "blur"
          }
        ],
        en_cname: [
          {
            required: true,
            message: this.$t("Ad.name_home_input"),
            trigger: "blur"
          }
        ],
        "zh-cn_image": [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        "zh-tw_image": [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        en_image: [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        "zh-tw_mobile_img": [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        "zh-cn_mobile_img": [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        en_mobile_img: [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        url_link: [
          {
            message: this.$t("Ad.url_link_input"),
            trigger: "blur"
          }
        ],
        mobile_link_url: [
          {
            message: this.$t("Ad.url_link_input"),
            trigger: "blur"
          }
        ],
        sort_id: [
          {
            type: 'number',
            required: true,
            message: this.$t('sort_input'),
            trigger: 'blur'
          }
        ],
        beginDate: [
          { required: true, type: 'date', message: this.$t('Ad.beginDate_input'), trigger: 'change' }
        ],
        endDate: [
          { required: true, type: 'date', message: this.$t('Ad.endDate_input'), trigger: 'change' }
        ],
        status: [
          {
            required: true,
            message: ' ',
            trigger: "blur"
          }
        ],
        link_status: [
          {
            required: true,
            message: ' ',
            trigger: "blur"
          }
        ],
        link_type: [
          {
            required: true,
            message: ' ',
            trigger: "blur"
          }
        ],
        ad_type: [
          {
            required: true,
            message: ' ',
            trigger: "blur"
          }
        ],
      },
      show: this.modal
    }

  },
  created () {
    this.info()
  },
  mounted () {

  },
  methods: {
    info () {
      this.form.ad_id = this.$base.getRequest().id
      if (this.type != 'add') {
        this.$base.showLoading();
        this.$request.sendPost(
          'ad-item/before-upd',
          { ad_item_id: this.itemObj.ad_item_id },
          (success, data, error) => {
            this.$base.hideLoading();
            if (!success) return this.$base.alertErr(error.errmsg);
            this.form = data.info
            this.form.sort_id = this.form.sort_id * 1
            this.form.beginDate = data.info.begin_date;
            this.form.endDate = data.info.end_date;
          }
        );
      }
    },

    onCopyImgPc (num) {
      switch (num) {
        case 1:
          if (this.form['zh-cn_image'] == "") {
            this.$Message.error(this.$t('p_upload_img'));
            break;
          }
          this.form['zh-tw_image'] = this.form['zh-cn_image']
          this.form['en_image'] = this.form['zh-cn_image']
          break;
        case 2:
          if (this.form['zh-tw_image'] == "") {
            this.$Message.error(this.$t('p_upload_img'));
            break;
          }
          this.form['zh-cn_image'] = this.form['zh-tw_image']
          this.form['en_image'] = this.form['zh-tw_image']
          break;
        case 3:
          if (this.form['en_image'] == "") {
            this.$Message.error(this.$t('p_upload_img'));
            break;
          }
          this.form['zh-cn_image'] = this.form['en_image']
          this.form['zh-tw_image'] = this.form['en_image']
          break;
      }
    },
    onCopyImg (num) {
      switch (num) {
        case 1:
          if (this.form['zh-cn_mobile_img'] == "") {
            this.$Message.error(this.$t('p_upload_img'));
            break;
          }
          this.form['zh-tw_mobile_img'] = this.form['zh-cn_mobile_img']
          this.form['en_mobile_img'] = this.form['zh-cn_mobile_img']
          break;
        case 2:
          if (this.form['zh-tw_mobile_img'] == "") {
            this.$Message.error(this.$t('p_upload_img'));
            break;
          }
          this.form['zh-cn_mobile_img'] = this.form['zh-tw_mobile_img']
          this.form['en_mobile_img'] = this.form['zh-tw_mobile_img']
          break;
        case 3:
          if (this.form['en_mobile_img'] == "") {
            this.$Message.error(this.$t('p_upload_img'));
            break;
          }
          this.form['zh-cn_mobile_img'] = this.form['en_mobile_img']
          this.form['zh-tw_mobile_img'] = this.form['en_mobile_img']
          break;
      }

    },

    changeDate (e) {
      this.form.begin_date = e;
    },
    changeDate2 (e) {
      this.form.end_date = e;
    },
    cancel () {
      this.$emit('cancel');
    },
    error () {
      this.$Message.error(this.$t("improve_information"));
    },
    ontabs (item) {
      this.tabs = item
    },
    handleBeforeUpload (file, num) {
      this.$base.showLoading();
      this.$base.uploadPicimg(file, '').then(res => {
        this.$base.hideLoading();
        if (res.url) {
          switch (num) {
            case 1:
              this.form['zh-cn_image'] = res.url
              break;
            case 2:
              this.form['zh-tw_image'] = res.url
              break;
            case 3:
              this.form.en_image = res.url
              break;
            case 4:
              this.form['zh-cn_mobile_img'] = res.url
              break;
            case 5:
              this.form['zh-tw_mobile_img'] = res.url
              break;
            case 6:
              this.form.en_mobile_img = res.url
              break;
          }
        }
      });
    },
    submit (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$base.showLoading();
          this.$request.sendPost(
            this.type == 'add' ? 'ad-item/add' : 'ad-item/upd',
            this.form,
            (success, data, error) => {
              this.$base.hideLoading();
              if (!success) return this.$base.alertErr(error.errmsg);
              this.cancel()
              this.$emit('onOk');
            }
          );
        } else {
          this.error()
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .modal {
  .list {
    width: 100%;
    padding: 30px;
  }
  .ivu-tabs-nav-scroll {
    display: flex;
    justify-content: center;
  }
  .demo-upload-list {
    display: inline-block;
    width: 300px;
    height: 150px;
    text-align: center;
    line-height: 100px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    margin-right: 4px;
  }
  .demo-upload-list img {
    width: 100%;
    height: 100%;
    border: 1px solid #dcdee2;
  }
  .ivu-upload-drag {
    height: 150px;
  }
  .ivu-btn-small {
    height: 24px;
    padding: 0 7px;
    font-size: 14px;
    border-radius: 3px;
  }
  .ivu-tabs {
    overflow: inherit;
  }
  .photo_tip {
    color: #c5c8ce;
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/edu/ad/module/ad_edit.vue